import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';



const AssignRoleOrTeam = ({ open, onClose, projectId, memberId, type, refreshData }) => {
  const [roles, setRoles] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('');
  const { t } = useTranslation();
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await api.get('/api/roles', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setRoles(response.data);
      } catch (error) {
        
      }
    };

    const fetchTeams = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await api.get(`/api/teams/${projectId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setTeams(response.data);
      } catch (error) {
      }
    };

    fetchRoles();
    fetchTeams();
  }, [projectId]);

  const handleAssign = async () => {
    try {
        const token = localStorage.getItem('token');
        if (type === 'role') {
            await api.patch(`/api/projects/${projectId}/members/${memberId}/role`, { roleId: selectedRole }, {
                headers: { Authorization: `Bearer ${token}` }
            });
        } else if (type === 'team') {
            await api.post(`/api/projects/${projectId}/teams/${selectedTeam}/members`, { userId: memberId }, {
                headers: { Authorization: `Bearer ${token}` }
            });
        }
        refreshData();
        onClose();
    } catch (error) {
    }
};



  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
  <DialogTitle>{type === 'role' ? t('assign_role') : t('assign_team')}</DialogTitle>
  <DialogContent>
    {type === 'role' ? (
      <FormControl fullWidth margin="normal">
        <InputLabel>{t('select_role')}</InputLabel>
        <Select
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
        >
          {roles.map((role) => (
            <MenuItem key={role.id} value={role.id}>{role.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : (
      <FormControl fullWidth margin="normal">
        <InputLabel>{t('select_team')}</InputLabel>
        <Select
          value={selectedTeam}
          onChange={(e) => setSelectedTeam(e.target.value)}
        >
          {teams.map((team) => (
            <MenuItem key={team.id} value={team.id}>{team.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={onClose} color="secondary">{t('cancel')}</Button>
    <Button onClick={handleAssign} color="primary">{t('assign')}</Button>
  </DialogActions>
</Dialog>
  );
};

export default AssignRoleOrTeam;
